export default __webpack_public_path__ + "static/media/python.65742be7.png";